import dynamic from "next/dynamic"
const CheckBoxGroup = dynamic(() => import("../_input/checkbox/checkBoxGroup"))
const RadioGroup = dynamic(() => import("../_input/radio/radioGroup"));



export default function HandleQuestion({ constant, selected, setSelected, step = null }) {
    return (
        constant?.mode === "radio" ?
            <RadioGroup
                title={constant?.title}
                selected={selected}
                setSelected={setSelected}
                name={constant?.name}
                list={constant?.items}
                step={step}
                specfic
            />
            :
            <CheckBoxGroup
                title={constant?.title}
                selected={selected}
                setSelected={setSelected}
                name={constant?.name}
                list={constant?.items}
                specfic
            />
    )
}